/**
 * Layar penuh browser sungguhan (`§G8.1`).
 *
 * Overlay setinggi viewport saja tidak cukup untuk yang diminta operator:
 * bilah alamat browser dan chrome sistem tetap memakan layar, dan di TV pos
 * satpam itu berarti gambar tidak pernah benar-benar mengisi layar. Fullscreen
 * API menghilangkan keduanya — pola yang sama dipakai aplikasi DVR.
 *
 * Kegagalan **tidak** dinaikkan ke UI: permintaan ini bisa ditolak karena tidak
 * ada gestur pemakai, karena kebijakan iframe, atau karena browsernya memang
 * tidak punya Fullscreen API (iOS Safari di `<div>`). Dalam semua keadaan itu
 * overlay setinggi viewport tetap tampil dan tetap bisa dipakai — jadi yang
 * hilang cuma bilah alamatnya, bukan fiturnya.
 */
export function mintaLayarPenuh(el?: HTMLElement): () => void {
  const target = el ?? document.documentElement;

  void target.requestFullscreen?.({ navigationUI: 'hide' }).catch(() => undefined);

  return () => {
    // Hanya keluar kalau memang kita yang masuk: menutup viewer tidak boleh
    // menendang keluar orang yang menekan F11 sendiri sebelum membukanya.
    if (document.fullscreenElement) void document.exitFullscreen?.().catch(() => undefined);
  };
}
